import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import {
  TopBarContainer,
  TopBar,
  TopBarLeft,
  TopBarRight,
  TopBarTitle,
  TopBarMenu,
  TopBarMenuTab,
  MenuTabContent
} from "../styled-components/TopBar";
import InfoDialog from "../components/InfoDialog";
import { makeGetConfigValue } from "../selectors/config";
import { generateShortcutText } from "../util/keyShortcutUtils";
import localize from "../util/localizeUtils";
import { actions as assetsActions } from "../actions/assets";
import { actions as contentActions } from "../actions/content";
import DarkLightModeButton from "./DarkLightModeButton";

const Mousetrap = window.Mousetrap;

const TopBarLeftTabs = styled(TopBarLeft)`
  width: 100%;
`;

class Header extends React.Component {
  componentDidMount() {
    this.bindShortcuts();
  }

  componentWillUnmount() {
    this.unbindShortcuts();
  }

  getRoute = () => {
    if (this.context.router.isActive("/runningorders/")) {
      return "RUNDOWNS";
    } else if (this.context.router.isActive("/assets/")) {
      return "TEMPLATES";
    } else if (this.context.router.isActive("/content/")) {
      return "CONTENT";
    } else if (this.context.router.isActive("/saved/")) {
      return "SAVED";
    }
    return "TEMPLATES";
  };

  bindShortcuts = () => {
    const {
      openBrowseTemplates,
      openBrowseContent,
      openRundowns
    } = this.props.shortcuts;
    Mousetrap.bindGlobal(openBrowseTemplates, () => {
      hashHistory.push("/assets");
      this.props.getAssets();
    });
    Mousetrap.bindGlobal(openBrowseContent, () => {
      hashHistory.push("/content");
      this.props.loadContent(this.props.assetType);
    });
    Mousetrap.bindGlobal(openRundowns, () => {
      hashHistory.push("/runningOrders");
    });
  };

  unbindShortcuts = () => {
    const {
      openBrowseTemplates,
      openBrowseContent,
      openRundowns
    } = this.props.shortcuts;
    Mousetrap.unbind(openBrowseTemplates);
    Mousetrap.unbind(openBrowseContent);
    Mousetrap.unbind(openRundowns);
  };

  render() {
    const route = this.getRoute();
    const { isModifierActive, getAssets, loadContent } = this.props;
    return (
      <TopBarContainer>
        <TopBar>
          <TopBarLeftTabs>
            <TopBarMenu>
              <TopBarMenuTab
                active={route === "TEMPLATES"}
                onClick={() => {
                  hashHistory.push("/assets");
                  getAssets();
                }}
              >
                <MenuTabContent>
                  {generateShortcutText(
                    localize("browseTemplatesTab"),
                    isModifierActive
                  )}
                </MenuTabContent>
              </TopBarMenuTab>
              <TopBarMenuTab
                active={route === "CONTENT"}
                onClick={() => {
                  hashHistory.push("/content", "localcontent");
                  loadContent(this.props.assetType);
                }}
              >
                <MenuTabContent>
                  {generateShortcutText(
                    localize("browseContentTab"),
                    isModifierActive
                  )}
                </MenuTabContent>
              </TopBarMenuTab>
              {this.props.showSavedItems ? (
                <TopBarMenuTab
                  active={route === "SAVED"}
                  onClick={() => {
                    hashHistory.push("/saved");
                  }}
                >
                  <MenuTabContent>
                    {generateShortcutText(
                      localize("savedItemsTab"),
                      isModifierActive
                    )}
                  </MenuTabContent>
                </TopBarMenuTab>
              ) : (
                ""
              )}
              {this.props.showRunningOrders ? (
                <TopBarMenuTab
                  active={route === "RUNDOWNS"}
                  onClick={() => {
                    hashHistory.push("/runningOrders");
                  }}
                >
                  <MenuTabContent>
                    {generateShortcutText(
                      localize("runningOrdersTab"),
                      isModifierActive
                    )}
                  </MenuTabContent>
                </TopBarMenuTab>
              ) : (
                ""
              )}
            </TopBarMenu>
          </TopBarLeftTabs>
          <TopBarRight>
            <TopBarTitle>
              <DarkLightModeButton />
            </TopBarTitle>
            <TopBarTitle>
              <InfoDialog />
            </TopBarTitle>
            <TopBarTitle>LUCI</TopBarTitle>
          </TopBarRight>
        </TopBar>
      </TopBarContainer>
    );
  }
}

Header.contextTypes = {
  router: PropTypes.object
};

Header.propTypes = {
  showRunningOrders: PropTypes.bool.isRequired,
  showSavedItems: PropTypes.bool.isRequired,
  shortcuts: PropTypes.shape({
    openBrowseTemplates: PropTypes.arrayOf(PropTypes.string),
    openBrowseContent: PropTypes.arrayOf(PropTypes.string),
    openRundowns: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  isModifierActive: PropTypes.bool.isRequired,
  getAssets: PropTypes.func.isRequired,
  assetType: PropTypes.string.isRequired,
  loadContent: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const getConfigValue = makeGetConfigValue();
  return {
    showRunningOrders:
      getConfigValue(state, "userConfig", "runningOrdersDisplay", "show") ===
      "show",
    showSavedItems:
      getConfigValue(state, "userConfig", "savedItemsDisplay", "hide") ===
      "show",
    shortcuts: state.keyShortcuts.shortcuts,
    isModifierActive: state.keyShortcuts.isModifierActive,
    assetType: state.content.assetType
  };
};

const mapActionCreators = {
  getAssets: assetsActions.getAssets,
  loadContent: contentActions.loadContent
};

export default connect(mapStateToProps, mapActionCreators)(Header);



// WEBPACK FOOTER //
// ./app/components/Header.js